const entana=[
   {
    vidiny:"38.000 Ar",
    sary:"/varotra/images/Entana/Bodysuite-Sà2XL.png",
    sary1:"/varotra/images/Entana/Bodysuite-38000ar.png",
    taille:"S-M-L-XL-2XL",
    karazany:"bodysuite"
   },
   {
      vidiny:"40.000 Ar",
      sary:"/varotra/images/Entana/Bodysuite2-Là3XL.png",
      sary1:"/varotra/images/Entana/Bodysuite2-40000ar.png",
      taille:"L-XL-2XL-3XL",
      karazany:"bodysuite"
     },
     {
      vidiny:"40.000 Ar",
      sary:"/varotra/images/Entana/Ensemble-Sà3XL.png",
      sary1:"/varotra/images/Entana/Ensemble-40000ar.png",
      taille:"S-M-L-XL-2XL-3XL",
      karazany:"ensemble"
     },
     {
      vidiny:"45.000 Ar",
      sary:"/varotra/images/Entana/Ensemble2-XLà4XL.png",
      sary1:"/varotra/images/Entana/Ensemble2-45000ar.png",
      taille:"XL-2XL-3XL-4XL",
      karazany:"ensemble"
     },
     {
      vidiny:"40.000 Ar",
      sary:"/varotra/images/Entana/Ensemble3-SàXL.png",
      sary1:"/varotra/images/Entana/Ensemble3-40000ar.png",
      taille:"S-M-L-XL",
      karazany:"ensemble"
     },
     {
      vidiny:"30.000 Ar",
      sary:"/varotra/images/Entana/Gaine-Sà2XL.png",
      sary1:"/varotra/images/Entana/Gaine-30000ar.png",
      taille:"S-M-L-XL-2XL",
      karazany:"gaine"
     },
     {
     vidiny:"25.000 Ar",
     sary:"/varotra/images/Entana/Gaine2-Sà2XL.png",
     sary1:"/varotra/images/Entana/Gaine2-25000ar.png",
     taille:"S-M-L-XL-2XL",
     karazany:"gaine"
    },
    {
    vidiny:"37.000 Ar",
    sary:"/varotra/images/Entana/Gaine3-Sà2XL.png",
    sary1:"/varotra/images/Entana/Gaine3-37000ar.png",
    taille:"S-M-L-XL-2XL",
    karazany:"gaine"
   },
   {
      vidiny:"30.000 Ar",
      sary:"/varotra/images/Entana/Harnais.png",
      sary1:"/varotra/images/Entana/Harnais-30000ar.png",
      taille:"standard",
      karazany:"harnais"
     },
     {
      vidiny:"10.000 Ar",
      sary:"/varotra/images/Entana/Masque-10000ar.png",
      sary1:"/varotra/images/Entana/Masque.png",
      taille:"standard",
      karazany:"masque"
     },
     {
      vidiny:"35.000 Ar",
      sary:"/varotra/images/Entana/Soutien-Là4XL.png",
      sary1:"/varotra/images/Entana/Soutien-35000ar.png",
      taille:"L-XL-2XL-3XL-4XL",
      karazany:"soutien"
     },
     {
      vidiny:"36.000 Ar",
      sary:"/varotra/images/Entana/Soutien2-Sà3XL.png",
      sary1:"/varotra/images/Entana/Soutien2-36000ar.png",
      taille:"S-M-L-XL-2XL-3XL",
      karazany:"soutien"
     },
     {
      vidiny:"36.000 Ar",
      sary:"/varotra/images/Entana/Soutien3-SàXL.png",
      sary1:"/varotra/images/Entana/Soutien3-36000ar.png",
      taille:"S-M-L-XL",
      karazany:"soutien"
     },
     {
      vidiny:"36.000 Ar",
      sary:"/varotra/images/Entana/Soutien4-SàXL.png",
      sary1:"/varotra/images/Entana/Soutien4-36000ar.png",
      taille:"S-M-L-XL",
      karazany:"soutien"
     },
     {
      vidiny:"36.000 Ar",
      sary:"/varotra/images/Entana/Soutien5-Sà2XL.png",
      sary1:"/varotra/images/Entana/Soutien5-36000ar.png",
      taille:"S-M-L-XL-2XL",
      karazany:"soutien"
     },

]

export default entana